/** Plain text for a playbook API row when paragraph_text is empty (OOXML fallback). */
export function playbookParagraphPlainText(row: Record<string, unknown>): string {
  const pt = String(row.paragraph_text ?? '').trim();
  if (pt) return pt;
  const xml = row.paragraph_xml;
  if (typeof xml !== 'string' || !xml.trim()) return '';
  return xml
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
